<template>
  <v-btn
    :color="color"
    :outlined="outlined"
    :plain="plain"
    :large="large"
    rounded
    class="font-weight-bold  text-center"
    :class="{'my-3':!removeMargin}"
    :disabled="disabled"
    :loading="loading"
    @click="action"
  >
    {{ label }}
    <v-icon v-if="icon" size="24" :color="iconColor" right class="mx-0 px-4">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean },
    label: {
      type: String,
      default: null
    },
    action: {
      type: Function,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: 'third'
    },
    outlined: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'third'
    },
    removeMargin: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    plain: { type: Boolean }
  }
};
</script>
